import { supabase } from '../lib/supabase';

export const syncToGoogleSheets = async (payload: Record<string, unknown>) => {
  try {
    const { data, error } = await supabase
      .from('app_settings' as any)
      .select('value')
      .eq('key', 'google_sheets_webhook_url')
      .single();
    if (error) throw error;
    const url = ((data as unknown) as { value: string } | null)?.value;
    if (!url) return;

    await fetch(url, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify(payload),
    });
  } catch {
    // ignore sync failures
  }
};
